import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=d313e84e&scoped=true"
import script from "./AboutHero.vue?vue&type=script&lang=js"
export * from "./AboutHero.vue?vue&type=script&lang=js"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=d313e84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d313e84e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
